import { render } from "./DeleteChampionsForm.vue?vue&type=template&id=d5496218&scoped=true"
import script from "./DeleteChampionsForm.vue?vue&type=script&lang=js"
export * from "./DeleteChampionsForm.vue?vue&type=script&lang=js"

import "./DeleteChampionsForm.vue?vue&type=style&index=0&id=d5496218&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5496218"]])

export default __exports__